import React from 'react';
import styles from './InlineOpenGraph.module.scss';
import OpenGraphCard from '../OpenGraphCard';
import logger from '../../utils/logger';

const InlineOpenGraph = ({
  openGraphData,
  isLoading,
  onRemoveCard,
  className = '',
  error,
}) => {
  logger.debug('[InlineOpenGraph] render', {
    openGraphDataLength: openGraphData?.length || 0,
    isLoading,
    className,
    hasError: Boolean(error),
  });

  if (!openGraphData || openGraphData.length === 0) {
    logger.debug('[InlineOpenGraph] no data, skipping render');
    return null;
  }

  logger.debug('[InlineOpenGraph] rendering cards', {
    isLoading,
    hasError: Boolean(error),
    openGraphDataLength: openGraphData.length,
  });

  return (
    <div className={`${styles.inlineOpenGraph} ${className}`}>
      {isLoading && (
        <div className={styles.loadingIndicator}>
          <div className={styles.spinner}></div>
          <span>Creating link previews...</span>
        </div>
      )}

      {error && (
        <div className={styles.errorIndicator}>
          <span>
            {error.message.includes('timeout') ||
            error.message.includes('Safety timeout')
              ? '⏰ Link previews are taking longer than expected. Please try again.'
              : 'Failed to load link previews. Please try again.'}
          </span>
        </div>
      )}

      {openGraphData.map((ogData, index) => (
        <div key={`${ogData.url}-${index}`} className={styles.cardWrapper}>
          {typeof onRemoveCard === 'function' && (
            <button
              className={styles.removeButton}
              onClick={() => onRemoveCard(ogData.url)}
              type="button"
              aria-label="Remove link preview"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path
                  d="M12 4L4 12M4 4L12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          )}

          <OpenGraphCard
            data={ogData}
            compact={true}
            className={styles.inlineCard}
          />
        </div>
      ))}
    </div>
  );
};

export default InlineOpenGraph;
